import React from 'react';
import { useWarehouseApp } from '../hooks/useWarehouseApp';
import { WarehouseAppContext } from '../context/WarehouseAppContext';

interface WarehouseProviderProps {
  children: React.ReactNode;
}

export const WarehouseProvider: React.FC<WarehouseProviderProps> = ({ children }) => {
  const warehouseAppState = useWarehouseApp();

  return (
    <WarehouseAppContext.Provider value={warehouseAppState}>
      {children}
    </WarehouseAppContext.Provider>
  );
};
